import { createMapAction } from "chalet-shared";

export const actionCreators = {
    trackOpenRoomClickStarted: createMapAction(
        "TRACK_OPEN_ROOM_CLICK_STARTED",
        (x: { roomId: string }) => x
    ),
    trackOpenRoomClickFinished: createMapAction(
        "TRACK_OPEN_ROOM_CLICK_FINISHED",
        (x: { roomId: string }) => x
    ),
};
